import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-areas:
    'image'
    'title'
    'message';
  margin: 0 auto;
  max-width: 785px;
  padding: 32px 20px;
  transition: all 0.3s ease-in;

  @media (min-width: 768px) {
    grid-gap: 16px 32px;
    grid-template-areas:
      'image title'
      'image message';
    grid-template-columns: 1fr 1.5fr;
    padding: 92px 20px 105px;
  }
`

export const Image = styled.img`
  display: none;
  grid-area: image;
  transition: all 0.3s ease-in;

  @media (min-width: 768px) {
    align-items: center;
    display: flex;
    justify-content: center;
    max-width: 100%;
  }
`

export const Title = styled.h3`
  align-items: flex-end;
  display: flex;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 500;
  grid-area: title;
  line-height: 36px;
  transition: all 0.3s ease-in;

  @media (min-width: 768px) {
    font-size: 32px;
    line-height: 48px;
  }
`

export const Message = styled.p`
  color: #696977;
  font-size: 16px;
  font-weight: 400;
  grid-area: message;
  line-height: 24px;
  transition: all 0.3s ease-in;
`
